<script setup lang="ts">
import { benefitDialogVisibility } from '@/components/layout/GoatBenefit/GoatBenefitDialog'
</script>

<template>
  <el-dialog
    v-model="benefitDialogVisibility"
    class="p-0 bg-transparent"
    :show-close="true"
    width="min(95vw, 670px)"
    modal-class="bg-neutral-900/90"
    center
  >
    <goat-benefits modal-mode />
  </el-dialog>
</template>

<style scoped lang="postcss">

</style>
